var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"color":"grey lighten-3","height":"40"}},[_c('v-toolbar-title',{class:_vm.titlePadding},[_vm._v("Custom Editor Help")])],1),_c('v-card-text',[_c('div',{class:_vm.listPadding,domProps:{"innerHTML":_vm._s(_vm.helpText)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }